// SystemShips.tsx — Renders the 3D ships currently in the focused system. This is the
// component that SUBSCRIBES to the (high-frequency) sim snapshot, so the parent
// SystemDetail doesn't re-render every snapshot (which would churn its planets). The
// ships mount inside SystemDetail's star-centered group, so their course-local
// positions land correctly.
import type { Galaxy, StarSystem } from '../types';
import { useSim } from '../state/context';
import { isEmpireShip, ownerColor } from '../state/economy';
import { Ship } from './Ship';

interface Props {
  galaxy: Galaxy;
  system: StarSystem;
}

export function SystemShips({ galaxy, system }: Props) {
  const sim = useSim();
  if (!sim) return null;
  // Ships present inside this system: flying (transit) or parked in orbit at one of its
  // worlds. Ships crossing a hyperlane render on the galaxy map (ShipMarker), not here. The
  // snapshot's gameTime is the base each ship predicts its physics forward from.
  return (
    <>
      {(sim.ships ?? [])
        .filter((s) => (s.phase === 'transit' || s.phase === 'orbit') && s.systemId === system.id)
        .map((s) => (
          <Ship key={s.id} galaxy={galaxy} ship={s} baseTime={sim.gameTime} tint={isEmpireShip(s) ? ownerColor(sim, s.owner) : undefined} />
        ))}
    </>
  );
}
